import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

class AboutMe extends React.Component {
    publications = (title, author, venue, award, link, videoLink, poster ) => (
        <div className="publication">
          <span className='title'><b>{title}</b></span>
          <span className='author'>{author.map((val,idx) => val === 'Kyung Je Jo' ? <span key={idx}><span className="author-me">{val}</span>{idx === author.length-1 ? '' : ', '}</span> : <span key={idx}>{val}{idx === author.length-1 ? '' : ', '}</span>)}</span>
          <span className='detail'>
            <span className='venue'><em>{venue}</em></span>
            {award ? <span>&nbsp;|&nbsp;</span> : ''}
            {award ? <span className='award'>{award}</span> : ''}
            {link ? <span>&nbsp;|&nbsp;</span> : ''}
            {link ? <a className='pdf' href={link}>PDF</a> : ''}
            {videoLink ? <span>&nbsp;|&nbsp;</span> : ''}
            {videoLink ? <a className='videoLink' href={videoLink}>Link to Video</a> : ''}
            {poster ? <span>&nbsp;|&nbsp;</span> : ''}
            {poster ? <a className='videoLink' href={poster}>Poster</a> : ''}
            { award || link || videoLink || poster ? '' : ' (to appear)'}
          </span>
        </div>
      )
    render() {
        return (
            <div className='section' id='publications'>
                <Header as='h3'>
                Publications
                </Header>
                <Header as='h5' className="subsection-header" style={{fontWeight: '600', color: '#4183c4'}}>
                    Posters, Workshop Papers
                </Header>
                <div className="section-content">
                    {this.publications(
                        'Supporting Instruction of Formulaic Sequences Using Videos at Scale',
                        ['Kyung Je Jo', 'Hyeonggeun Yun', 'Juho Kim'],
                        'L@S 2019 Works-in-Progress.',
                        '',
                        'https://kixlab.github.io/website-files/2019/l@s2019-FSIST-poster.pdf',
                        '',
                        'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/poster/FSIST_LAS2019.pdf'
                    )}
                    {this.publications(
                        'Exprgram: A Language Learning Interface for Mastering Pragmatic Competence',
                        ['Kyung Je Jo', 'John Joon Young Chung', 'Juho Kim'],
                        'CHI 2018 Extended Abstracts.',
                        '',
                        'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/publications/Exprgram_CHILBW2018.pdf',
                        'https://www.youtube.com/watch?v=Cs8CSz3-MK0',
                        'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/poster/Exprgram_CHILBW2018.pdf',
                    )}
                    {this.publications(
                        'Exprgram: A Video-based Language Learning Interface Powered by Learnersourced Video Annotations',
                        ['Kyung Je Jo', 'John Joon Young Chung', 'Juho Kim'],
                        'HCOMP 2017 Workshop on Human Computation for Image and Video Analysis (GroupSight 2017).',
                        'Best Paper Runner-Up',
                        'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/publications/Exprgram_GroupSight2017.pdf',
                        'https://www.youtube.com/watch?v=J0Y9tzJ-8xY',
                        'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/poster/Exprgram_GroupSight2017.pdf',
                    )}
                </div>
            </div>
        )
    }
}

export default AboutMe;


// WEBPACK FOOTER //
// ./src/components/Publications.jsx